// extracted by mini-css-extract-plugin
export default {"intro-subtitle":"pages_intro-subtitle__AwGGS","right":"pages_right__S8Wcz","preview-wrapper":"pages_preview-wrapper__Ufy8T","download-link":"pages_download-link__NXsX6"};